import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CustomValidators } from '../../../../spartacus/custom/shared/utils/validators/custom-validators';
import { RecaptchaService } from '../../../../spartacus/features/recaptcha/recaptcha.service';
import { Newsletter } from './model/custom-newsletter.model';
import { CustomNewsletterService } from './services/custom-newsletter.service';

@Component({
  selector: 'app-custom-newsletter',
  templateUrl: './custom-newsletter.component.html',
  styleUrls: ['./custom-newsletter.component.scss'],
  standalone: false
})
export class CustomNewsletterComponent implements OnInit, OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  showMoreForm = false;
  checkText = true;
  newsLetterForm?: UntypedFormGroup;
  newsLetter = {} as Newsletter;

  constructor(
    protected fb: UntypedFormBuilder,
    protected elementRef: ElementRef,
    protected newsLetterService: CustomNewsletterService,
    protected recaptchaService: RecaptchaService
  ) {}

  ngOnInit(): void {
    this.newsLetterForm = this.fb.group({
      exclusiveRole: ['', Validators.required],
      particular: [true, Validators.required],
      company: ['', Validators.required],
      email: ['', [Validators.required, CustomValidators.emailValidator]],
      agree: [false, Validators.requiredTrue]
    });
  }

  particular(value: any): void {
    this.newsLetterForm?.controls.particular.setValue(value);
    this.newsLetterForm?.controls.company.setValue(!value);
    this.checkText = true;
  }

  company(value: any): void {
    this.newsLetterForm?.controls.particular.setValue(!value);
    this.newsLetterForm?.controls.company.setValue(value);
    this.checkText = false;
  }

  showLegalText(): void {
    this.showMoreForm = true;
  }

  submitForm(): void {
    if (this.newsLetterForm?.valid) {
      this.recaptchaService
        .getToken()
        .then((token) => {
          if (token) {
            this.subscriptions.add(
              this.recaptchaService.validateRecaptchaToken(token).subscribe((response) => {
                if (response?.status === 200) {
                  this.newsLetter = this.newsLetterForm?.value;
                  this.newsLetterService.subscribeNewsletter(this.newsLetter, this.newsLetterForm);
                  this.showMoreForm = false;
                } else {
                  this.recaptchaService.recaptchaError('forms.recaptcha.invalidToken');
                }
              })
            );
          } else {
            this.recaptchaService.recaptchaError('forms.recaptcha.invalidToken');
          }
        })
        .catch(() => this.recaptchaService.recaptchaError(null));
    } else {
      this.newsLetterForm?.markAllAsTouched();
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
